var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _c(
      "div",
      { staticClass: "is-weiXin-tip hidden", class: { show: _vm.is_weixn() } },
      [
        _c("img", {
          staticClass: "tip-open",
          attrs: {
            src: require("@/assets/case-share-detail/what_tip.png"),
            alt: ""
          }
        })
      ]
    ),
    _c("img", {
      staticClass: "banner",
      attrs: { src: require("@/assets/imgs/share-page/Frame1321314813@2x.png") }
    }),
    _c("div", { staticClass: "content-wrap" }, [
      _c("img", {
        staticClass: "banner1",
        attrs: {
          src: require("@/assets/imgs/share-page/Frame1321314799@2x.png")
        }
      }),
      _c("h4", [_vm._v(_vm._s(_vm.detail.title))]),
      _c("div", { staticClass: "desc-date" }, [
        _vm._v(_vm._s(_vm.detail.createTime.substring(0, 10)) + " "),
        _c("a", [_vm._v("#" + _vm._s(_vm.detail.typeLabel))]),
        _vm._v(" " + _vm._s(_vm.detail.pv) + "浏览 "),
        _c("i", { staticClass: "fr" }, [
          _vm._v("作者：" + _vm._s(_vm.detail.lawyerName) + "律师")
        ])
      ]),
      _c("div", { staticClass: "con-box" }, [
        _c(
          "div",
          {
            staticClass: "box-lawyer flex-space-between flex flex-align-center"
          },
          [
            _c("div", { staticClass: "lawyer-info flex" }, [
              _c("div", { staticClass: "lawyer-img" }, [
                _c("img", {
                  staticClass: "lawyer-info-header",
                  attrs: { src: _vm.detail.lawyerAvatar }
                }),
                _vm.detail.isVip
                  ? _c("img", {
                      staticClass: "lawyer-info-icon",
                      attrs: {
                        src: require("@/assets/imgs/share-page/icon-v.png")
                      }
                    })
                  : _vm._e()
              ]),
              _c("div", [
                _c("h5", [
                  _vm._v(_vm._s(_vm.detail.lawyerName) + " "),
                  _c("i", [_vm._v(_vm._s(_vm.detail.workCityName))])
                ]),
                _c("p", { staticClass: "lawyer-info-tag font11" }, [
                  _c("i", [
                    _vm._v("擅长" + _vm._s(_vm.detail.lawyerWorkFieldList[0]))
                  ]),
                  _c("i", [_vm._v("官方认证")])
                ])
              ])
            ]),
            _c("div", { staticClass: "box-case tc" }, [
              _c("p", [_vm._v("近期被咨询")]),
              _c("p", [
                _c("a", [_vm._v(_vm._s(_vm.detail.consultNum))]),
                _vm._v(" 次")
              ])
            ])
          ]
        )
      ]),
      _c("img", {
        staticClass: "banner",
        attrs: {
          src: require("@/assets/imgs/share-page/Frame1321314773@2x.png")
        }
      }),
      _c("div", { staticClass: "html-con" }, [
        _c("div", { domProps: { innerHTML: _vm._s(_vm.detail.content) } })
      ]),
      _c("img", {
        staticClass: "banner",
        attrs: {
          src: require("@/assets/imgs/share-page/Frame1321314772@2x.png")
        }
      }),
      _c("div", { staticClass: "html-con" }, [
        _vm._v(_vm._s(_vm.detail.quote))
      ]),
      _vm._m(0),
      _c("img", {
        staticClass: "banner",
        attrs: { src: require("@/assets/imgs/share-page/Group8163@2x.png") }
      })
    ]),
    _c("div", { staticClass: "footers" }, [
      _c("button", { on: { click: _vm.openApp } }, [_vm._v("立即前往APP")]),
      _c("p", [
        _vm._v("您还没安装法临律师端APP？请点击 "),
        _c("a", { on: { click: _vm.buttonDownload } }, [_vm._v("立即下载")])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-desc" }, [
      _vm._v(
        " 本文版权归原作者所有，内容仅代表作者本人观点，不代表法临平台的立场。如有任何疑问或需要删除请通过 "
      ),
      _c("a", [_vm._v("【客服中心】")]),
      _vm._v("联系我们。 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }